import React, { Fragment, useEffect, useRef, useMemo } from 'react';
import { mount } from './mount';
import * as css from 'styles/program/single.scss';

export const ProgramsDetailsBackground = mount('app-programs-details-background', props => {

  const background = useRef();
  const stickyElement = props.container.parentNode.parentNode;

  const adjustWidth = () => {
    const ratio = props.container.parentNode.offsetWidth / window.innerWidth;
    background.current.style.transform = `scaleX(${1/ratio})`;
  }

  const observer = new IntersectionObserver(function([{ isIntersecting }]){
    background.current.classList.toggle(css.static, !isIntersecting);
  }, {
    rootMargin: '0px 0px -100% 0px'
  });

  useEffect(() => {
    adjustWidth();
    observer.observe(stickyElement);
    window.addEventListener('resize', adjustWidth);
    return () => {
      observer.disconnect();
      window.removeEventListener('resize', adjustWidth);
    }
  }, []);

  return (
    <div className={css.detailsBackground} ref={background} />
  );

});
